import React, { createContext, useContext, useState } from 'react';

export type NotificationType = 'success' | 'error';

export interface Notification {
  id: number;
  message: React.ReactNode;
  type: NotificationType;
}

interface NotificationContextType {
  notifications: Notification[];
  showNotification: (message: React.ReactNode, type?: NotificationType) => void;
  hideNotification: (id: number) => void; 
}

const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

export const NotificationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [notifications, setNotifications] = useState<Notification[]>([]);

  const showNotification = (message: React.ReactNode, type: NotificationType = 'success') => {
    const newNotification: Notification = {
      id: new Date().getTime(),
      message,
      type,
    };
    setNotifications(prev => [...prev, newNotification]);
  };
  
  const hideNotification = (id: number) => {
    setNotifications(prev => prev.filter(n => n.id !== id));
  };
  
  const value = { notifications, showNotification, hideNotification };

  return (
    <NotificationContext.Provider value={value}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification must be used inside a NotificationProvider');
  }
  return context;
};